import React from 'react';
import { StyledInput, StyledLabel, ErrorMessageBox } from './style';

export const Input = ({ width, label, type, size, placeholder, name, error, onChange, value, min }) => {
    return (
        <div>
            {label && <StyledLabel htmlFor={name}>{label}</StyledLabel>}
            <StyledInput
                size={size}
                type={type}
                name={name}
                onChange={onChange}
                min={min}
                value={value}
                placeholder={placeholder}
            />
            {error && <ErrorMessageBox width={width}>{error}</ErrorMessageBox>}
        </div>
    );
};

export const TextInput = ({ input, meta: { touched, error }, name, label }) => (
    <div>
        {label && <StyledLabel htmlFor={name}>{label}</StyledLabel>}
        <StyledInput {...input} type={'text'} />
        {/* <input {...input} type={'text'} /> */}
        {touched && error && <span>{error}</span>}
    </div>
);



// WEBPACK FOOTER //
// ./src/UI/Components/Inputs/CreateEditInput/Input.js